import React from 'react'
import styles from './General.module.css'
import Numbers from "../../../../../../components/Analytics/Numbers/Numbers";
import ChartBar from "../ChartBar/ChartBar";
import EmptyData from "../../../../../../components/Analytics/EmptyData/EmptyData";
import { useTranslation } from "react-i18next";
import { useCurrentBranch } from "../../../../../../hooks/useCurrentBranch";
import { Roles } from "../../../../../../config";
import Invis from "../../../../../../components/Filter/Invis";
import VideoModal from "../../../../../../components/VideoModal";
import YOUTUBE_LINKS from "../../../../../../config/youtubeLinks";

export default function General(props) {
    const {
      average_check,
      cashback_amount,
      data,
      payment_total,
      transactions,
      type,
      changePeriod,
      status,
      chart_data,
      payment_from_private_balance,
      dinamicSalesDateFrom,
      dinamicSalesDateTo,
      changeDate,
    } = props
    const { t } = useTranslation();
    const { currentRole } = useCurrentBranch()

    return (
        <div className={styles.container}>
            <div className={styles.containerHead}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                <h2>{t('NSSidebar.sales')}</h2>
                <VideoModal url={YOUTUBE_LINKS.Analytics} />
              </div>
            </div>
            {currentRole === Roles.ADMINISTRATOR ? (
              <div style={{ marginLeft: 'auto', width: '100%', padding: '24px 10px 0 0px'}}>
                <Invis />
              </div>
            ) : null}
            <div className={styles.numbers}>
                {average_check && cashback_amount && payment_total && transactions ?
                    <Numbers
                        average_check={average_check}
                        cashback_amount={cashback_amount}
                        payment_total={payment_total}
                        transactions={transactions}
                        payment_from_private_balance={payment_from_private_balance}
                    />
                    :
                    <EmptyData marginTop={20}/>
                }


                {/*<DropdownSelector*/}
                {/*    changePeriod={changePeriod}*/}
                {/*    status={status}*/}
                {/*    type={type}*/}
                {/*/>*/}
            </div>
            <ChartBar
                average_check={average_check}
                cashback_amount={cashback_amount}
                payment_total={payment_total}
                transactions={transactions}
                type={type}
                chart_data={chart_data}
                changePeriod={changePeriod}
                dinamicSalesDateFrom={dinamicSalesDateFrom}
                dinamicSalesDateTo={dinamicSalesDateTo}
                changeDate={changeDate}
            />
        </div>

    )
}
